<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane label="APP乐迷版" name="1" link="/operation/updateNotify/listyuemi"></el-tab-pane>
            <el-tab-pane label="APP专业版" name="2" link="/operation/updateNotify/list"></el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
export default {
    props:{
        name:{
            type: String,
            default: '1'
        }
    },
    data(){
        return{
            activeName: this.name
        }
    },
    methods:{
        clickEvent(tab){
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link)
        }
    }
}
</script>